export default class Textbox {
  constructor(properties) {
    this.properties = {
      left: 0,
      top: 0,
      height: 0,
      width: 0,
      fontColor: '',
      fontSize: 12,
      fontWeight: 'normal',
      fontStyle: 'none',
      textTransform: 'none',
      align: 'left',
      ...properties,
    }

    return this
  }

  getSelectedSlideIndex() {
    return new window.OfficeExtension.Promise(function(resolve, reject) {
      window.Office.context.document.getSelectedDataAsync(
        window.Office.CoercionType.SlideRange,
        function(asyncResult) {
          try {
            if (asyncResult.status == 'failed') {
              console.error('Error', asyncResult.error.message)
              return reject(asyncResult.error.message)
            }

            return resolve(asyncResult.value.slides[0].index)
          } catch (error) {
            console.log('Error on getSelectedSlideIndex', error)
            return reject(error)
          }
        }
      )
    })
  }

  async syncContext() {
    await window.PowerPoint.run(async context => {
      await context.sync()
    })
  }

  async add(slideIndex, str) {
    await window.PowerPoint.run(async context => {
      const shapes = context.presentation.slides.getItemAt(slideIndex - 1)
        .shapes

      const textbox = shapes.addTextBox(str)
      textbox.left = this.properties.left
      textbox.top = this.properties.top
      textbox.height = this.properties.height
      textbox.width = this.properties.width
      textbox.name = str
      textbox.textFrame.textRange.font.size = this.properties.fontSize
      textbox.textFrame.textRange.font.color = this.properties.fontColor
      textbox.textFrame.textRange.font.name = 'Inter'
      textbox.textFrame.textRange.paragraphFormat.horizontalAlignment = this.properties.align

      if (this.properties.fontWeight === 'bold') {
        textbox.textFrame.textRange.font.bold = true
      }
      if (this.properties.fontStyle === 'italic') {
        textbox.textFrame.textRange.font.italic = true
      }

      // https://docs.microsoft.com/en-us/javascript/api/powerpoint/powerpoint.shapefontunderlinestyle?view=powerpoint-js-preview
      // textbox.textFrame.textRange.font.underline =
      //   window.PowerPoint.ShapeFontUnderlineStyle[this.properties.textTransform]

      // await context.sync()
    })
  }
}
